import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect } from '../FormInputs';
import { useCurrentUser } from '../../contexts/CurrentUser';
import { topicModelingTranslationLanguageOptions } from '../../utils/languages';

interface TopicModelingSubgroupProps {
  form: any;
  isDisabled?: boolean;
}

export const TopicModelingSubgroup: React.FC<TopicModelingSubgroupProps> = ({
  form,
  isDisabled = false,
}) => {
  const { t } = useTranslation();
  const [currentUser] = useCurrentUser();

  return (
    <form.Subscribe
      selector={(state: any) => state.values.topicModelingEntity}
      children={(topicModelingEntity: any) => {
        let topicModelingEntityOptions = [
          { label: t('Events only legacy'), value: 'EVENTS_AND_OPINIONS_V2' },
          {label: t('Events only'), value: 'EVENTS_ONLY_BETA'}
        ];

        if (currentUser?.is_super_admin) {
          topicModelingEntityOptions.push({
            label: t('Events & opinions legacy'),
            value: 'EVENTS_AND_OPINIONS',
          });
        }

        return (
          <div className="group-card-row">
            <div className="group-card-header">
              {t('Topic modeling')}
              <div className="group-card-secondary-text">
                <p>{t('Transform information space into coherent topics')}</p>
              </div>
            </div>

            <div className="form-element-group">
              <FormSelect
                form={form}
                name="topicModelingEntity"
                label={t('Topic modeling entity')}
                placeholder={t('Choose entity for topic modeling analysis')}
                options={topicModelingEntityOptions}
                required={!isDisabled}
                disabled={isDisabled}
              />

              {topicModelingEntity && (
                <FormSelect
                  form={form}
                  name="topicModelingTranslationLanguage"
                  label={t('Translate topics into')}
                  placeholder={t('Choose language')}
                  options={topicModelingTranslationLanguageOptions(t)}
                  disabled={
                    isDisabled ||
                    (topicModelingEntity?.value !== 'EVENTS_AND_OPINIONS_V2' &&
                    topicModelingEntity?.value !== 'EVENTS_ONLY_BETA')
                  }
                  isClearable={false}
                />
              )}
            </div>
          </div>
        );
      }}
    />
  );
};